module.exports = __webpack_public_path__ + "img/white-question-mark.ee5e23ff.svg";